import { useContext } from 'react';
import Button from '@mui/material/Button';
import { UserContext } from '../contexts/UserProvider';

export const PreAuthLayout = () => {
    const { signInWithGoogle } = useContext(UserContext);

    return (
        <Button variant="contained" color="primary" onClick={signInWithGoogle}>
            Sign in with Google
        </Button>
    );
  }
